import ForgetPasswordModal from './ForgetPasswordModal';

export default ForgetPasswordModal;
